import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiInstance from '../utils/apiInstance';
import countryCodes from '../utils/CountryCodes.json';
import { ToastContainer, toast } from 'react-toastify';
import 'react-tooltip/dist/react-tooltip.css'

const AddRestaurant = () => {
    const [data, setData] = useState({});
    const [countryCode, setCountryCode] = useState([]);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        setCountryCode(countryCodes);
    }, []);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image" && files.length > 0) {
            const file = files[0];
            if (!file.type.startsWith("image/")) {
                toast.error("Please select a valid image file.");
                return;
            }
            setData((prevData) => ({
                ...prevData,
                [name]: file,
            }));
            setImagePreview(URL.createObjectURL(file));
        } else {
            setData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (
            !data.ownerCountry_code ||
            !data.ownerName?.trim() ||
            !data.ownerLocation ||
            !data.ownerPhone ||
            !data.email ||
            !data.password ||
            !data.confirmPassword ||
            !data.restaurantName ||
            !data.restaurantCountry_code ||
            !data.restaurantPhone ||
            !data.restaurantAddress ||
            !data.open_time ||
            !data.close_time
        ) {
            toast.error("Please fill in all required fields");
            return;
        }
        if (!data.image) {
            toast.error("Please select an image");
            return
        }
        if (data.image && data.image.size > (1024 * 1024 * 6)) {
            toast.error("Image size must be less than 6MB");
            return;
        }
        if (!/^[A-Za-z\s]+$/.test(data.ownerName)) {
            toast.error("owner name cannot be a number");
            return;
        }
        if (isNaN(data.ownerPhone)) {
            toast.error("Enter a valid owner's phone number");
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
            toast.error("Enter a valid email address");
            return;
        }
        if (data.password.length < 5 || data.password.length > 12) {
            toast.error("Password must be 5-12 characters");
            return;
        }
        if (data.password !== data.confirmPassword) {
            toast.error("Password and Confirm Password do not match");
            return;
        }
        if (isNaN(data.restaurantPhone)) {
            toast.error("Enter a valid restaurant's phone number");
            return;
        }

        const formData = new FormData();
        formData.append("ownerCountry_code", data.ownerCountry_code);
        formData.append("ownerName", data.ownerName);
        formData.append("ownerPhone", data.ownerPhone);
        formData.append("email", data.email);
        formData.append("ownerLocation", data.ownerLocation)
        formData.append("image", data.image);
        formData.append("password", data.password);

        formData.append("restaurantName", data.restaurantName);
        formData.append("restaurantCountry_code", data.restaurantCountry_code);
        formData.append("restaurantPhone", data.restaurantPhone);
        formData.append("restaurantAddress", data.restaurantAddress);
        formData.append("open_time", data.open_time);
        formData.append("close_time", data.close_time);

        setLoading(true);
        try {
            await apiInstance.post(`/addRestaurant`, formData);
            toast.success("Restaurant added successfully");
            setTimeout(() => {
                navigate(-1);
            }, 1000);
        } catch (error) {
            if (error.response) {
                toast.error(
                    `${error.response.data?.message || "Something went wrong"
                    }`
                );
            } else {
                toast.error("Request failed: Network error or server is down.");
            }
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
    const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisible(!confirmPasswordVisible);


    return (
        <>
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={true} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card my-4">
                            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                <div className="bg-info shadow-dark border-radius-lg">
                                    <h6 className="text-white text-capitalize ps-3">
                                        Add Restaurant
                                    </h6>
                                </div>
                            </div>
                            <form onSubmit={handleSubmit} style={{ position: 'relative' }}>
                                {loading && (
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                                            zIndex: 1000,
                                        }}
                                    >
                                        <div className="spinner-border text-info" role="status" style={{ width: '50px', height: '50px' }}>
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                <div className="card-body">
                                    <div className="form-group col-3 mx-auto d-flex justify-content-center">
                                        <div className="restaurant_profile mt-2" data-aspect="1/1">
                                            <img
                                                src={imagePreview || '/noimage.png'}
                                                alt="Preview"
                                                style={{
                                                    borderRadius: "10px",
                                                    width: "200px",
                                                    height: "200px",
                                                    marginBottom: "5px",
                                                }}
                                            />
                                            <input
                                                type="file"
                                                name="image"
                                                className="form-control "
                                                onChange={handleChange}
                                                accept=".jpg,.jpeg,.png"
                                                style={{
                                                    paddingLeft: "10px",
                                                    color: 'white',
                                                    width: '200px'
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-5 ">
                                        <div className="shadow-dark border-radius-lg ps-3 py-1" style={{ backgroundColor: "#0d6efd" }}>
                                            <h6 style={{ color: "white" }}>Owner Details</h6>
                                        </div>
                                        <div className='row mt-2'>
                                            <div className='col-lg-6'>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="ownerName">Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="ownerName"
                                                        value={data.ownerName || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="email">Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="email"
                                                        value={data.email || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="ownerPhone">Phone No.</label>
                                                    <div className="d-flex">
                                                        <select
                                                            name="ownerCountry_code"
                                                            className="form-control  cursor-pointer me-1"
                                                            required
                                                            value={data.ownerCountry_code || ""}
                                                            onChange={handleChange}
                                                            style={{
                                                                width: "75px",
                                                                paddingLeft: "10px",
                                                                color: 'white',
                                                            }}
                                                        >
                                                            <option value="">c.code</option>

                                                            {countryCode.map((code, index) => (
                                                                <option key={index} value={code.code}>
                                                                    {code.code}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <input
                                                            type="tel"
                                                            className="form-control "
                                                            required
                                                            autoComplete="off"
                                                            name="ownerPhone"
                                                            value={data.ownerPhone || ""}
                                                            onChange={handleChange}
                                                            style={{
                                                                flex: 1,
                                                                paddingLeft: "10px",
                                                                color: 'white',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-lg-6'>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="password">Password</label>
                                                    <div className="input-group position-relative">
                                                        <input
                                                            type={passwordVisible ? "text" : "password"}
                                                            className="form-control "
                                                            required
                                                            autoComplete='off'
                                                            name="password"
                                                            value={data.password || ""}
                                                            onChange={handleChange}
                                                            maxLength={12}
                                                            style={{
                                                                paddingLeft: "10px",
                                                                color: 'white'
                                                            }}
                                                        />
                                                        <i onClick={togglePasswordVisibility} className={`fas ${passwordVisible ? 'fa-eye' : 'fa-eye-slash'}`} style={{ position: "absolute", right: '5px', top: '14px', zIndex: '10', cursor: 'pointer', color: 'black' }} />
                                                    </div>
                                                </div>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="confirmPassword">Confirm Password</label>
                                                    <div className="input-group position-relative">
                                                        <input
                                                            type={confirmPasswordVisible ? "text" : "password"}
                                                            className="form-control "
                                                            required
                                                            autoComplete='off'
                                                            name="confirmPassword"
                                                            value={data.confirmPassword || ""}
                                                            onChange={handleChange}
                                                            maxLength={12}
                                                            style={{
                                                                paddingLeft: "10px",
                                                                color: 'white'
                                                            }}
                                                        />
                                                        <i onClick={toggleConfirmPasswordVisibility} className={`fas ${confirmPasswordVisible ? 'fa-eye' : 'fa-eye-slash'}`} style={{ position: "absolute", right: '5px', top: '14px', zIndex: '10', cursor: 'pointer', color: 'black' }} />
                                                    </div>
                                                </div>

                                                <div className="form-group mb-2">
                                                    <label htmlFor="ownerAddress">Address</label>
                                                    <input
                                                        type="text"
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="ownerLocation"
                                                        value={data.ownerLocation || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* restaurant */}
                                    <div className="mt-5 ">
                                        <div className="shadow-dark border-radius-lg ps-3 py-1" style={{ backgroundColor: "#0d6efd" }}>
                                            <h6 style={{ color: "white" }}>Restaurant Details</h6>
                                        </div>
                                        <div className='row mt-2'>
                                            <div className='col-lg-6'>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="restaurantName">Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="restaurantName"
                                                        value={data.restaurantName || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="restaurantPhone">Phone No.</label>
                                                    <div className="d-flex">
                                                        <select
                                                            name="restaurantCountry_code"
                                                            className="form-control  cursor-pointer me-1"
                                                            required
                                                            value={data.restaurantCountry_code || ""}
                                                            onChange={handleChange}
                                                            style={{
                                                                paddingLeft: "10px",
                                                                width: "75px",
                                                                color: 'white',
                                                            }}
                                                        >
                                                            <option value="">c.code</option>

                                                            {countryCode.map((code, index) => (
                                                                <option key={index} value={code.code}>
                                                                    {code.code}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <input
                                                            type="tel"
                                                            className="form-control "
                                                            required
                                                            autoComplete='off'
                                                            name="restaurantPhone"
                                                            value={data.restaurantPhone || ""}
                                                            onChange={handleChange}
                                                            style={{
                                                                flex: 1,
                                                                paddingLeft: "10px",
                                                                color: 'white'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="restaurantAddress">Address</label>
                                                    <input
                                                        type="text"
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="restaurantAddress"
                                                        value={data.restaurantAddress || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-lg-6'>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="openTime">Opening-Time</label>
                                                    <input
                                                        type="time"
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="open_time"
                                                        value={data.open_time || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>

                                                <div className="form-group mb-2">
                                                    <label htmlFor="closeTime">Closing-Time</label>
                                                    <input
                                                        type="time"
                                                        className="form-control "
                                                        required
                                                        autoComplete='off'
                                                        name="close_time"
                                                        value={data.close_time || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                </div>
                                <div className="mx-4 text-end">
                                    <button
                                        type="submit"
                                        className="btn btn-info"
                                        style={{ marginRight: "10px" }}
                                    >
                                        Add
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddRestaurant;
